const agreeMent = `
<h1>隐私协议</h1>
<p>更新时间2023年9月11日</p>
<p>生效时间2023年9月11日</p>

<p>“慕思”一直以来高度重视诚信和透明度，致力于与顾客在互信互利的基础上建立稳固持久的关系。“慕思”非常重视用户隐私，请您在向“慕思”提交个人数据前阅读并了解本《隐私协议》（以下简称“本协议”）的内容（特别是以粗体形式标注的内容），确保您充分理解和同意后再开始使用。
本协议在制定时充分考虑到您的需求，帮助您全面了解我们的个人信息收集和使用惯例，同时确保您最终能控制提供给我们的个人信息。本协议规定我们如何收集、使用、披露、处理和存储您使用我们慕思的网站、应用程序、小程序、社交互动页面、线下活动等各类线上及线下场景中提供给我们的信息。本协议下“个人信息”指通过信息本身或通过关联其他信息后能够识别特定个人的数据。我们将严格遵守本协议来使用这些信息。
如果您不同意本协议任何内容，您应立即停止使用我们平台服务。当您使用我们平台提供的任一服务时，即表示您已同意我们按照本协议来合法收集、使用和保护您的个人信息。如您有任何疑问，请及时通过官方渠道联系我们。
</p>

<p>本协议将帮助您了解以下内容：</p>

<p>一、我们如何收集信息</p>

<p>二、我们如何使用您的个人信息</p>

<p>三、我们如何分享或披露您的个人信息</p>

<p>四、我们如何保护您的个人信息安全</p>

<p>五、未成年人保护</p>

<p>六、本隐私协议如何更新</p>

<p>七、如何联系我们</p>



<p>一、我们如何收集信息</p>

<p>我们仅收集实现产品或服务功能所需要的必要的信息：</p>

<p>1.1您在使用我们产品或服务时主动提供的个人信息。</p>

<p>1.2我们可能在您使用产品或接受服务时所获取的信息：</p>

<p>1.2.1位置信息：您在使用产品或接受服务时所在的位置。例如您在使用附近门店功能时，为了快速的为您提供门店服务，我们可能需要获取您的位置。</p>

<p>1.2.2日志信息：当您使用产品或接受服务时，我们可能会自动收集您使用我们产品或服务的终端、软件、使用习惯等详细使用情况。例如您的设备型号、搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</p>

<p>1.2.3其他信息：您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>

<p>1.2.4从第三方合作商获取的信息</p>

<p>我们亦有可能获得在您使用第三方合作商的产品或服务时所记录、产生、分享的相关信息。比如我们在第三方合作商开设运营账号，您使用该第三方合作商客户端接受我们提供的产品或服务时，我们可能会获得您的相关信息。故而，亦建议您了解第三方合作商的服务条款或者隐私政策。</p>

<p>二、如何使用您的个人信息</p>

<p>当您使用相关服务时，我们可出于以下目的收集、处理、使用和/或保存您的个人信息：</p>

<p>2.1为了提供履行我们的服务或履行与服务有关的义务，包括管理和维护。</p>

<p>2.2为您提供您已经请求或同意接收的信息或服务，包括代表我们或第三方合作商向您提供优惠或促销信息；</p>

<p>2.3处理您的注册或其他服务请求，包括验证您的账户或其他信息是否激活且有效，沟通、处理和/或回应您的查询、请求或投诉；</p>

<p>2.4用于改善我们自身的服务，或用于数据分析目的（包括趋势研究或分析）。我们有可能将所收集的信息用于数据分析，该等信息经过统计加工后将不含身份识别内容，用于分析或了解用户如何使用我们的服务，以便进一步改善、创新我们的服务。</p>

<p>2.5针对您的服务使用体验，以及我们对隐私协议做出的变更，与您联系；</p>

<p>2.6将我们收集的任何数据提供、转移和/或存储到我们的母公司、子公司、联营公司或附属公司，或位于中华人民共和国境内或境外的任何提供管理、数据处理、计算机或其他服务的代理商、承包商或第三方合作商，以便我们实现本协议规定的目的；</p>

<p>2.7如果我们进行合并、收购、融资或出售资产，或出现涉及转让我们的部分或全部业务资产的任何其他情况，向涉及我们谈判或转让事宜的个人或机构而进合法的披露；</p>

<p>2.8基于互联网及社会经济的高速发展，仅凭我们自身的能力可能无法独立完成服务的全过程，我们还需要将您的个人信息提供给第三方合作商以用于完成我们的服务，比如支付、结算、礼品寄送业务；</p>

<p>2.9用于您同意的任何其他目的，例如本隐私协议规定的目的以及任何适用法律允许或要求的其他目的。</p>

<p>三、如何分享或披露您的个人信息</p>

<p>我们不会与除我们母公司、子公司、联营公司或附属公司以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>

<p>3.1基于您的事先同意而分享、披露。</p>

<p>3.2仅为实现业务处理之目的，我们可能会与我们的母公司、子公司、联营公司或附属公司、必要的第三方合作伙伴分享、披露您的个人信息，并要求其按照我们的说明、要求及本隐私协议及其他必要的安全保护措施处理上述信息，并仅用以下用途：</p>

<p>3.2.1向您提供我们的产品或服务；</p>

<p>3.2.2管理、维护及改善我们的服务；</p>

<p>3.2.3行使或履行我们在本隐私协议中的权利或义务；</p>

<p>3.2.4用于我们对会员用户的广告投放、会员营销、营销分析等，我们可能将您的设备标识、手机号等信息提供给此类的第三方数据服务商；</p>

<p>进一步，在与第三方分享上述信息时，我们将从合理的技术手段（如加密）来保障您的信息安全。</p>

<p>3.3以下情形下，分享或披露您的个人信息无需事先征得您的同意：</p>

<p>3.3.1与国家安全、公共安全、重大利益有关的；</p>

<p>3.3.2遵守法院判决、裁定或其他法律程序，或者遵守相关政府机关或其他法定授权组织的要求；</p>

<p>3.3.3出于维护您、我们或其他个人或组织的生命、财产或其他合法权益，合理且必要的用途；</p>

<p>3.3.4从合法公开披露的信息中收集的个人信息。</p>

<p>3.4此外，去除掉个人身份识别标识且确保数据接收方无法复原并重新识别个人身份的信息，不属于个人隐私信息，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

<p>四、我们如何保护您的个人信息安全</p>

<p>4.1我们采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>

<p>4.2我们采取合理可行的措施，尽力避免收集无关的个人信息。</p>

<p>4.3互联网并非绝对安全的环境，请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>

<p>五、未成年人保护</p>

<p>如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私声明，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>

<p>六、本协议如何更新</p>

<p>我们可能依据法律法律变更或业务发展适时修订本协议内容。如该等修订可能导致您于本协议下权利实质减损，我们将在修订后通过显著官方页面通知、公告或其他合理、可行的方式通知您。如您选择继续使用我们的服务，即表示同意本协议的修订内容亦对您有约束力。</p>

<p>七、如何联系我们</p>

<p>如果您对本协议或个人信息保护有任何问题，请通过以下方式与我们联系；</p>

<p>客服热线: 400-777-0077</p>

`;
export default agreeMent;
